import { useLayoutEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { PRO_TRIAL_PROMO, storePromo } from "../promo";

export const useCapturePromo = () => {
  const [searchParams] = useSearchParams();
  const promo = searchParams.get("promo");

  useLayoutEffect(() => {
    if (promo === PRO_TRIAL_PROMO) {
      storePromo(promo);
    }
  }, [promo]);
};
